// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2IyHw","toggle":"styles_toggle__33zqK","preview":"styles_preview__2_x8x"};